import { Category } from '@/enums/category'

const mutations = {
  setCurrentCategory(state: any, category: Category) {
    state.currentCategory = category
  }
}

const getters = {
  category(state: any) {
    return state.currentCategory
  },
}

const actions = {
}

const state = () => ({
  currentCategory: Category.FEATURED as Category
})

export default {
  namespaced: true,
  mutations,
  getters,
  state,
  actions,
};
